import React from 'react'
import '../assets/css/progressBarAnimate.css'

export default class SkillSet extends React.Component {

  getIconSizeClassName () {
    let iconSizeClassName = ""
    switch (this.props.iconSize) {
      case "s":
        iconSizeClassName = "fa-lg"
        break;

      case "m":
        iconSizeClassName = "fa-2x"
        break;

      case "l":
        iconSizeClassName = "fa-custom"
        break;

      default:
        iconSizeClassName = "fa-lg"
        break;
    }
    return iconSizeClassName
  }

  validateSkillScore () {
    return (this.props.skillScore > 100 || this.props.skillScore < 0) ? 50 : this.props.skillScore
  }

  render () {
    return (
      <div className="sk" onClick={this.testWithArrowFunc}>
        <div className="sk-icon">
          <span className="icon is-large">

            { this.props.icons.map((icon, index) => {
                return (
                  <i key={ index } className={`${ icon } ${ this.getIconSizeClassName() }`}></i>
                )
              })
            }

          </span>
        </div>
        <div className="sk-name">
          <h1 className="title is-5 sk-title">{ this.props.skillName }</h1>
          <progress className="subtitle progress" value={ this.validateSkillScore() } max="100"></progress>
        </div>
      </div>
    )
  }
}